"use client";
import React from "react";
import dynamic from "next/dynamic";
import type { MapProps } from "modules/common/components/map/Map";
import MapSkeleton from "modules/common/components/skeletons/map/MapSkeleton";
import { MapErrorBoundary } from "modules/common/components/map/MapErrorBoundary";

// Create dynamic component once at module level — never inside a component body
const MapLazy = dynamic(() => import("modules/common/components/map/Map"), {
  loading: () => <MapSkeleton />,
  ssr: false,
});

const DynamicFindStoresMap = (props: MapProps) => {
  return (
    <MapErrorBoundary className={props.className}>
      <MapLazy {...props} />
    </MapErrorBoundary>
  );
};

export default DynamicFindStoresMap;
